import React from 'react';
import injectSaga from '../../utils/injectSaga';
import injectReducer from '../../utils/injectReducer';
import reducer, {
	moduleName,
	sectionsRootSaga,
} from '../../ducks/sections.duck';
import { compose } from 'redux';

const InjectableSections = () => {
	return null;
};

const withSaga = injectSaga({ key: moduleName, saga: sectionsRootSaga });
const withReducer = injectReducer({ key: moduleName, reducer });

export default compose(
	withReducer,
	withSaga,
)(InjectableSections);
